const getToken = () => {
  const items = window.location.pathname
    .split("/")
    .filter((item) => Boolean(item));
  return items[items.length - 1];
};

export default getToken;
